export const APP_NAME = "Efel";
export const APP_VERSION = "1.0.0";
export const PERSIST_STORE_NAME = "admin";
export const REDIRECT_URL_KEY = "redirectUrl";
